/* TOP7 discount code box (snippets/top7-cart-discount.liquid).
   Applies codes to the Shopify cart via /cart/update.js {discount}, so they carry into checkout.
   Loaded once from layout/theme.liquid: scripts inside the re-rendered drawer HTML never run. */
(function () {
  if (window.__t7dc) return; window.__t7dc = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pendingMsg = null;
  function boxes() { return Array.prototype.slice.call(document.querySelectorAll('.t7dc')); }
  function applied() { var b = boxes()[0]; return b ? (b.getAttribute('data-codes') || '').split('|').filter(Boolean) : []; }
  function showMsg(b, text, bad) {
    var m = b.querySelector('.t7dc-msg'); if (!m) return;
    m.textContent = text; m.hidden = !text; m.classList.toggle('is-bad', !!bad); b.classList.toggle('is-bad', !!bad);
  }
  // restore the message (and a rejected code) after the drawer section is re-rendered
  function restore() {
    var pm = pendingMsg; pendingMsg = null; if (!pm) return;
    boxes().forEach(function (b) {
      showMsg(b, pm.text, pm.bad);
      if (pm.val != null) { var i = b.querySelector('.t7dc-input'); if (i) i.value = pm.val; }
    });
  }
  function send(codes, done) {
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    var sections = helper && helper.getSectionsToRender ? helper.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var run = function (ev) {
      return fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(','), sections: sections }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (ev && ev.settle) { try { ev.settle(cart, []); } catch (e) {} }
          done(cart);
          if (helper && helper.reRenderSections && cart.sections) helper.reRenderSections(cart.sections);
          document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));
          setTimeout(function () {
            boxes().forEach(function (nb) { nb.classList.remove('is-busy'); var ab = nb.querySelector('.t7dc-apply'); if (ab) ab.disabled = false; });
            restore();
          }, 60);
          return cart;
        });
    };
    if (helper && helper.withCartLock) return helper.withCartLock(run, { type: 'shopify:cart:discount-update', context: 'cart', discountCodes: codes.map(function (c) { return { code: c }; }) });
    return run(null);
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('.t7dc-rm');
    if (!rm) return;
    e.preventDefault();
    var code = rm.getAttribute('data-code'), b = rm.closest('.t7dc'); b.classList.add('is-busy');
    send(applied().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }), function () { pendingMsg = null; });
  });
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('t7dc-input')) { var b = e.target.closest('.t7dc'); if (b.classList.contains('is-bad')) showMsg(b, '', false); }
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.classList || !e.target.classList.contains('t7dc-form')) return;
    e.preventDefault();
    var b = e.target.closest('.t7dc'), input = b.querySelector('.t7dc-input'), code = (input.value || '').trim().toUpperCase();
    if (!code || b.classList.contains('is-busy')) return;
    var badText = b.getAttribute('data-bad');
    var codes = applied().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }); codes.push(code);
    b.classList.add('is-busy'); b.querySelector('.t7dc-apply').disabled = true; showMsg(b, '', false);
    send(codes, function (cart) {
      var hit = (cart.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      var good = !!(hit && hit.applicable);
      if (!good) {
        // drop the invalid code again so it does not sit in the cart
        var keep = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
        if (keep.length !== (cart.discount_codes || []).length) fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
      }
      // success is shown by the re-rendered 'applied' row, so only a rejection needs a message
      pendingMsg = good ? { text: '', bad: false, val: '' } : { text: badText, bad: true, val: code };
    }).catch(function () { b.classList.remove('is-busy'); b.querySelector('.t7dc-apply').disabled = false; showMsg(b, badText, true); });
  });
})();
